export async function apiGetHubServer(): Promise<string> {
  const result = await fetch(`${import.meta.env.VITE_WSS_URL}/identify`);

  if (result.ok) {
    return await result.text();
  } else {
    throw result;
  }
}
